import {
    goalViewState,
} from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';

export const
    selectedIndex = (state, props) => goalViewState(state, props).ownerIndex || 0,
    options = (props) => {
        const
            options = [], {
                principalName,
                spouseName,
            } = props;

        if (principalName) {
            options.push(principalName);
        }

        if (spouseName) {
            options.push(spouseName);
        }
        return options;
    },
    selectedOwnerName = (state, props) => {
        const
            index = selectedIndex(state, props),
            optionsArray = options(props);

        if (index < 0 || index >= optionsArray.length) {
            // should throw but we don't have an error consumption mechanism so we default to the generic error string
            return ADV.settings.MsgLib.generic_error;
        }
        return `${optionsArray[index]}`;
    },
    selectedLabel = (state, props) => {
        const
            index = selectedIndex(state, props),
            optionsArray = options(props);

        if (index < 0 || index >= optionsArray.length) {
            // should throw but we don't have an error consumption mechanism so we default to the generic error string
            return ADV.settings.MsgLib.generic_error;
        }
        return `${optionsArray[index]}'s Insurance`;
    };
